import { findResults, removeItemByCode } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import actions from '../../../constants';
import { findAllDictionaryMarkdowns } from './state';

const destroyDataset = withDraft((draft, { items }) => {
  findAllDictionaryMarkdowns(draft, { items }, 'datasetCode').forEach((category) => {
    items.forEach(({ code }) => {
      findResults(draft.markdowns, category, code, 'datasetCode').forEach((item) => {
        draft.markdowns[category].results = removeItemByCode(draft.markdowns[category].results, item);
      });
    });
  });
});

export default {
  [actions.DESTROY_DATASET]: destroyDataset,
};
